import { HttpParams } from '@angular/common/http';

export class InterceptorHttpParams extends HttpParams {

    constructor(
        public blocking: boolean = true,
        params?: { [param: string]: string | string[] }
    ) {
        super({fromObject: params});
    }
}
